//
//
//
//
//
//
//
//
//

import { ref } from '@vue/composition-api'

export default {
  setup() {
    const values = ref([10, 60])

    return { values }
  },
}
